// rootReducer.js
import { combineReducers } from 'redux';
import {currentUserReducer} from './user_reducer';

const rootReducer = combineReducers({
  user: currentUserReducer,
  // Other reducers...
});

export default rootReducer;